const {setBadgeColors} = require("coremh/product/producttile");
const {
    loadMoreProductsIfLastProductIsInView,
    abortIfFooterIsInView,
    cleanUpPreviousCalls,
    setLoadingTextVisibility,
    updateQueryStringParameter,
    updateQueryString,
    isDesktop
} = require("coremh/components/utils");
//variable to save $ajaxRequest to abort it
var callsToAbort = [];

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $(".refinement.active").each(function () {
        $(this).removeClass("active");
        var activeDiv = $results.find("." + $.escapeSelector($(this)[0].className).replace(/\\ /g, "."));
        activeDiv.addClass("active");
        activeDiv.find("button.title").attr("aria-expanded", "true");
    });

    updateDom($results, ".refinements");
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        ".refinements": handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        ".search-result-display-count",
        ".header.page-title",
        ".product-grid",
        ".show-more",
        ".filter-bar",
        ".secondary-bar",
        ".sort-order-container > .custom-select"
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data("url");
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: "GET",
        success: function (response) {
            var hasChildren = $(response).find(".js-article-item").length;
            if (hasChildren) {
                $target.append(response);
            } else {
                $(".js-articles-not-found").removeClass("d-none");
            }

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the parameter of href URL with the value passed
 * If updatedUrl ends in "=", it removes it.
 * @param {String} url - Current href URL
 * @param {String} paramName - Parameter name of Href URL
 * @param {String} paramValue - Parameter value which needs to be set
 * @return {String} url - href URL
 */
function updateUrlParam(url, paramName, paramValue) {
    var encodedUrl  = encodeURIComponent(url);
    var searchParams = new URLSearchParams(encodedUrl);
    var currentParamValue = searchParams.get(paramName);

    if (currentParamValue) {
        if (currentParamValue !== paramValue) {
            searchParams.set(paramName, paramValue);
        }
    }

    var updatedUrl = decodeURIComponent(new URLSearchParams(searchParams).toString());
    return updatedUrl.slice(-1) === "=" ? updatedUrl.slice(0, -1) : updatedUrl;
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $("<div>").append($(response));
    var sortOptions = $tempDom.find(".grid-footer").data("sort-options").options;
    sortOptions.forEach(function (option) {
        $("option." + option.id).val(option.url);
    });
}

/**
 * Toggles the active state of the reset button and its related label, for the filters section
 *
 * @return {undefined}
 */
const toggleResetFiltersButton = () => {
    const $filterInputs = $(".refinements").find("input:not([id^='category-radio'], .sort-by-checkbox), .color-value");
    const $filterToggler = $(".secondary-bar, .reset-filter-label");

    $filterToggler.toggleClass("d-none", !$filterInputs.length);
};

module.exports = {
    initInfiniteScroll: function () {
        loadMoreProductsIfLastProductIsInView();
    },
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(".container").on("click", "button.filter-results", function () {
            const $refinementBar = $(".refinement-bar");

            $refinementBar.show();
            $refinementBar.siblings().attr("aria-hidden", true);
            $refinementBar.closest(".row").siblings().attr("aria-hidden", true);
            $refinementBar.closest(".tab-pane.active").siblings().attr("aria-hidden", true);
            $refinementBar.closest(".container.search-results").siblings().attr("aria-hidden", true);
        });

        if ($(window).width() > 768) {
            $(".refinements").find(".card").addClass("active");
        }

        toggleResetFiltersButton();
    },

    closeRefinements: function () {
        // Refinements close button
        $(".container").on("click", ".refinement-bar button.close, .secondary-bar .apply", function () {
            const $refinementBar = $(".refinement-bar");

            $refinementBar.hide();
            $refinementBar.siblings().attr("aria-hidden", false);
            $refinementBar.closest(".row").siblings().attr("aria-hidden", false);
            $refinementBar.closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $refinementBar.closest(".container.search-results").siblings().attr("aria-hidden", false);
        });
    },

    sort: function () {
        const _this = this;

        // Handle sort order menu selection
        $(".container").on("change", "[name=sort-order]", function (e) {
            e.preventDefault();
            $.spinner().start();

            const $sortOrderSelect = $(e.currentTarget);
            const pageSize = $("#sort-order-clp").data("page-size");
            const searchParams = new URLSearchParams(window.location.search);
            const pageParam = searchParams.get("page");
            let selectedOptionVal = this.value || $(this).find("option[selected]").val();
            let $currentResult = $(".search-result-display-count").find(".current-results");

            if (pageParam) {
                selectedOptionVal = updateQueryStringParameter(selectedOptionVal, "start", 0);
                selectedOptionVal = updateQueryStringParameter(selectedOptionVal, "sz", pageSize);
            }

            // Update sort values on mobile checkboxes
            const sortOptionId = $(this).find(":selected").data("id");
            $(`#${sortOptionId}`).val(selectedOptionVal);

            $.ajax({
                url: selectedOptionVal,
                data: { selectedUrl: selectedOptionVal },
                method: "GET",
                success: function (response) {
                    $(".product-grid").empty().html(response);
                    $currentResult.text($(".product-grid").find(".product-tile").length);
                    if (!$sortOrderSelect.find("option:selected").length) {
                        $sortOrderSelect.find("option[selected]").prop("selected", "selected");
                    }
                    _this.initSortInputDesktop();
                    $(".sort-by-checkbox").prop("checked", true).not(`[value="${selectedOptionVal}"]`).prop("checked", false);
                    setBadgeColors();
                    loadMoreProductsIfLastProductIsInView();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    sortMobile: function () {
        // Handle sort selection on small resolutions
        $("body").on("click", ".sort-by-checkbox", function (e) {
            e.preventDefault();

            $("[name=sort-order]").val(this.value).trigger("change");
        });
    },

    showMore: function () {
        // Show more products
        $(".container").on("click", ".show-more button", function (e) {
            e.stopPropagation();
            setLoadingTextVisibility(true);

            const $this = $(this);
            var $currentResult = $(".search-result-display-count").find(".current-results");
            var showMoreUrl = $this.data("url");

            e.preventDefault();
            $this.trigger("search:showMore", e);

            callsToAbort = cleanUpPreviousCalls(callsToAbort);
            callsToAbort.push($.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: "GET",
                success: function (response) {
                    $(".grid-footer").replaceWith(response);
                    setLoadingTextVisibility(false);
                    updateSortOptions(response);
                    $currentResult.text($(".product-grid").find(".product-tile").length);
                    setBadgeColors();
                    updateQueryString("page", $(".grid-footer").data("page-number") + 1, false);
                    loadMoreProductsIfLastProductIsInView();
                },
                error: function () {
                    setLoadingTextVisibility(false);
                    // As soon as the lastProduct appears and exceeds 600px or 500px
                    const customOptions = {root: document, rootMargin: `${isDesktop() ? -600 : -500}px 0px 0px 0px`};
                    loadMoreProductsIfLastProductIsInView(customOptions, 500);
                }
            }));

            const handlerParameters = callsToAbort;
            // As soon as the footer appears and exceeds 700px or 500px
            const customOptions = {root: document, rootMargin: `0px 0px ${isDesktop() ? -700 : -500}px 0px` };
            abortIfFooterIsInView(handlerParameters, customOptions);
        });
    },

    applyFilter: function () {
        const _this = this;
        var $document = $(document);

        // Handle refinement value selection and reset click
        $(".container").on(
            "click",
            ".refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .refinement-bar-wrapper .reset-filter-label",
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                $.spinner().start();
                var categoryURl = $(".category-refinemnt").attr("data-get-url");
                var currentFilterHref = $(this).data("href");
                var refinementURLParams = currentFilterHref.split("?");
                var params = refinementURLParams[1].toString();
                var pageURLSplit = document.location.href.split("?");
                var updatedParamsURL = pageURLSplit[0] + "?" + params;
                var categoryUpdatedParamsURL = categoryURl + "?" + params;
                var sortingOption = $("#sort-order-clp option:selected").val();
                var urlParams = new URLSearchParams(sortingOption);
                var srule = urlParams.get("srule");
                var currScroll = $(this).offset().top - $(document).scrollTop();
                var currId = $(this).find(".custom-control-input").attr("id");
                var $customBoxBar = $(".custom-box-bar");

                if (e.target.closest(".category-refinemnt")) {
                    history.replaceState(null, null, categoryUpdatedParamsURL);
                } else {
                    if ($customBoxBar.length == 0) {
                        history.replaceState(null, null, updatedParamsURL);
                    }
                }

                $(this).trigger("search:filter", e);

                var ajaxData = {
                    page: $(".grid-footer").data("page-number"),
                    selectedUrl: currentFilterHref
                };

                if (currentFilterHref && currentFilterHref.indexOf("srule") < 0) {
                    ajaxData.srule = srule;
                } else {
                    currentFilterHref = updateUrlParam(currentFilterHref, "srule", srule);
                }

                $.ajax({
                    url: currentFilterHref,
                    data: ajaxData,
                    method: "GET",
                    success: function (response) {
                        parseResults(response);
                        _this.initSortInputDesktop();

                        if ($customBoxBar.length) {
                            $customBoxBar.trigger("customBoxFiltered");
                        }

                        $.spinner().stop();
                    },
                    complete: function () {
                        toggleResetFiltersButton();
                        if ($(`#${currId}`).length) {
                            $document.scrollTop($(`#${currId}`).offset().top - currScroll);
                        } else {
                            $document.scrollTop(0);
                        }
                        var checked = $(".refinements input:checked").length > 0;
                        if (!checked) {
                            if (!$(".secondary-bar").find("btn").hasClass("disabled")) {
                                $(".secondary-bar").find("btn").addClass("disabled").prop("disabled", true);
                                $(".product-grid>div").each(function () {
                                    if ($(this).find(".add-to-card-cta").hasClass("grayedout")) {
                                        $(this).addClass("grayed");
                                    }
                                });
                            }
                            return false;
                        }
                        else {
                            $(".secondary-bar").removeClass("disabled").removeAttr("disabled", true);
                        }
                        $(".product-grid>div").each(function () {
                            if ($(this).find(".add-to-card-cta").hasClass("grayedout")) {
                                $(this).addClass("grayed");
                            }
                        });
                        loadMoreProductsIfLastProductIsInView();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $(".container").one("click", ".content-search", function () {
            const $contentSearchResults = $("#content-search-results");

            if (!$contentSearchResults.find(".js-article-item").length) {
                getContent($(this), $contentSearchResults);
            }
        });

        // Display the next page of content results from the search
        $(".container").on("click", ".show-more-content button", function () {
            getContent($(this), $("#content-search-results"));
            $(".show-more-content").remove();
        });
    },

    initSortInputDesktop: () => {
        // Add custom checkbox for sort input elements
        const addCheckbox = elem => $(`<div class="m-0 form-group custom-control custom-checkbox">
            <input type="checkbox"
                class="custom-control-input"
                id="${elem.text.replace(/\s+/g, "")}"
                name="${elem.text.replace(/\s+/g, "")}"
                value="true" ${elem.selected ? "checked" : ""}
            />
            <label class="custom-control-label custom-control-label-right custom-control-label-small text-nowrap" for="${elem.text.replace(/\s+/g, "")}">
                ${elem.text}
            </label>
        </div>`);
        const $sortingContainer = $(".sort-order-container");
        let sortMessage = "";

        if ($sortingContainer.length > 0) {
            sortMessage = $sortingContainer.data("sort-message");
        }

        const sortByPlaceholder = () => $("<span>" + sortMessage + "</span>");

        $("[name=sort-order]").select2({
            templateResult: addCheckbox,
            templateSelection : sortByPlaceholder,
            minimumResultsForSearch: -1,
            placeholder: sortMessage,
            dropdownParent: ".sort-order-container"
        });
    },

    showHideFiltersDesktop: () => {
        // Toggle filter section on desktop resolution
        $(".container").on("click", ".show-hide-filters-button", e => {
            $(".refinement-bar").toggleClass("hidden-filters-section").toggleClass("col-md-3");
            $(".top-filter-bar").toggleClass("d-block");
            $(".plp-offer-slot.fullWidthContent").toggleClass("fullPlpContent");
            $(".product-grid-container").toggleClass("col-md-9");
            $(".shrinkedPlp").toggleClass("PdpShrinked");
            $(".product-badges .mt-4").toggleClass("product-badges mt-3");
            $(e.currentTarget).toggleClass("hidden-filters");
        });
    },

    handleInlineAssets: () => {
        let $plpTiles = $(".js-plp-tile");
        const SINGLE_BLOCK = "singleBlock";

        $plpTiles.map((index, item) => {
            if ($(item).prev().hasClass(SINGLE_BLOCK) && $(item).next().hasClass(SINGLE_BLOCK)) {
                $(item).addClass("tile-between-singleBlock");
            }
        });
    }
};
